export default __webpack_public_path__ + "static/media/10_megphone-2.b750223c.jpg";